import { InputItem } from '@/models/inputItem'
import { InputItemSettings } from '@/const/InputItemSettings'
import { ApiResponseAcademy } from '@/models/apiResponses/academies'
import { ApiResponseBranch } from '@/models/apiResponses/branches'

/**
 * 管理画面の入力フォーム関係で使用するUtils
 */
export class ManagerInputUtils {
  /**
   * プレースホルダーのInputItem型を生成する
   * @param label ラベル
   */
  public static buildPlaceholder(label: string): InputItem {
    return this.buildInputItem('', label)
  }

  /**
   * 塾選択のプルダウン情報を生成する
   * @param placeholder プレースホルダー
   * @param apiResponse 塾一覧APIレスポンス
   * @returns 塾選択プルダウンオプション
   */
  public static buildAcademyInputItems(placeholder: InputItem, apiResponse?: ApiResponseAcademy[]): InputItem[] {
    const options = [placeholder]
    if (!apiResponse) return options

    return options.concat(
      apiResponse.map((response) => {
        return this.buildInputItem(String(response.id), response.academyName)
      })
    )
  }

  /**
   * 教室選択のプルダウン情報を生成する
   * @param placeholder プレースホルダー
   * @param apiResponse 教室一覧APIレスポンス
   * @returns 教室選択プルダウンオプション
   */
  public static buildBranchInputItems(placeholder: InputItem, apiResponse?: ApiResponseBranch[] | null): InputItem[] {
    const options = [placeholder]
    if (!apiResponse) return options

    return options.concat(
      apiResponse.map((response) => {
        return this.buildInputItem(String(response.id), response.branchName)
      })
    )
  }

  /**
   * テスト回数のプルダウン情報を生成する
   */
  public static buildNumberInputItems(): InputItem[] {
    return InputItemSettings.NUMBER_LIST.map((val) => {
      return this.buildInputItem(val.value, val.name)
    })
  }

  /**
   * テスト終了条件のプルダウン情報を生成する
   */
  public static buildEndConditionInputItems(): InputItem[] {
    return InputItemSettings.END_CONDITION_LIST.map((val) => {
      return this.buildInputItem(val.value, val.name)
    })
  }

  /**
   * フォーム入力で使用するInputItem型を生成する
   * @param value 値
   * @param label ラベル
   */
  private static buildInputItem(value: string, label: string): InputItem {
    return { value: value, label: label }
  }
}
